import Home from './Home'
import Board from './Board'
import Pay from './Pay'

import Detail from './Detail'
import Update from './Update'
import Worth from './Worth'

import Modify from './Modify'

import swal from 'sweetalert2'
import { get } from 'axios'

import store from '@/store'
import { yyyymmdd_ddmmyyy } from '@/utils'
import { API_ENDPOINT_BASE } from '@/constans'
import { LOADING, RESERVATIONS, FINANCING } from '@/store/mutations'

export default [
  {
    path: '/reservas',
    name: 'reservations',
    component: Home,
    beforeEnter (to, from, next) {
      store.commit(LOADING, true)
      get(API_ENDPOINT_BASE + '/reservations')
        .then(response => {
          store.commit(
            RESERVATIONS,
            response.data.map(data => ({
              id: data.id,
              data: { ...data, expiration: yyyymmdd_ddmmyyy(data.expiration) }
            }))
          )
          next()
        })
        .catch(error => {
          swal({ html: error.response.data.msg, type: 'error' })
          store.commit(RESERVATIONS, [])
        })
        .finally(() => store.commit(LOADING, false))
    }
  },
  {
    path: '/reservas/:id',
    name: 'reservation_guard',
    component: Board,
    beforeEnter: ({ name, params }, from, next) => {
      store.commit(LOADING, true)
      get(API_ENDPOINT_BASE + '/reservations/' + params.id)
        .then(({ data }) => {
          data.expiration = yyyymmdd_ddmmyyy(data.expiration)
          let reservations = [data]
          if (
            store.state.reservations &&
						store.state.reservations.some(reservation => reservation.id == params.id)
          ) {
            reservations = store.state.reservations.map(reservation =>
              reservation.id == params.id
                ? Object.assign(reservation, data)
                : reservation
            )
          }

          store.commit(RESERVATIONS, reservations)

          if (['canceled', 'expired'].includes(data.status) && name !== 'reservation') {
            next({ name: 'reservation', params })
          } else {
            next()
          }
        })
        .catch(error => {
          swal({ html: error.response.data.msg, type: 'error' })
          next({ name: 'reservations' })
        })
        .finally(() => {
          store.commit(LOADING, false)
        })
    },
    children: [
      {
        path: 'salida',
        name: 'reservation',
        component: Detail
      },
      {
        path: '/',
        name: 'reservation_passengers',
        component: Update
      },
      {
        path: 'modificar',
        name: 'reservation_update',
        component: Modify,
        beforeEnter: ({ params }, from, next) => {
          store
            .dispatch(
              'modify/INIT',
              store.state.reservations.find(
                reservation => reservation.id == params.id
              )
            )
            .then(next)
        }
      },
      {
        path: 'liquidacion',
        name: 'reservation_worth',
        component: Worth
      },
      {
        path: 'pagar',
        name: 'reservation_pay',
        component: Pay,
        beforeEnter: ({ params }, from, next) => {
          store.commit(LOADING, true)
          get(API_ENDPOINT_BASE + '/payments/financing.json')
            .then(({ data }) => {
              store.commit(FINANCING, data)
              next()
            })
            .catch(error => {
              store.commit(FINANCING, [])
              swal({
                type: 'error',
                title: 'Ocurrio un error',
                html: error.response.data.msg
              })
              next({ name: 'reservation', params: { id: params.id } })
            })
            .finally(() => store.commit(LOADING, false))
        }
      }
    ]
  }
]
